const ExercisesTypes = {
  SET_EXERCISES_LOADING: 'EXERCISES/SET_EXERCISES_LOADING',
  SET_EXERCISES_FAILURE: 'EXERCISES/SET_EXERCISES_FAILURE',
  SET_EXERCISES_SUCCESS: 'EXERCISES/SET_EXERCISES_SUCCESS',
};

export default ExercisesTypes;